import { ReactNode } from "react";

import type { SxProps } from "@mui/material/styles";

import SelectFormField from "components/select-form-field";
import useReferralSourceOptions from "features/patients/use-referral-source-options.hook";

type ReferralSourceFieldProps = {
  control: any;
  afterUpdate?: () => void;
  required?: boolean;
  sx?: SxProps;
  addButton?: ReactNode;
  disabled?: boolean;
};

export default function ReferralSourceField({
  control,
  afterUpdate,
  required,
  sx,
  addButton,
  disabled = false
}: ReferralSourceFieldProps) {
  const referralSourceOptions = useReferralSourceOptions();

  return (
    <SelectFormField
      name="referral_source"
      label="Referral Source"
      control={control}
      options={referralSourceOptions}
      required={required}
      afterUpdate={afterUpdate}
      addButton={addButton}
      disabled={disabled}
      sx={sx}
    />
  );
}
